import React, { CSSProperties } from 'react';
import numeral from "numeral";

export interface WidgetNumberProps {
  valor: number;
  showDecimals?: boolean;
  style?: CSSProperties;
}

export const Reais = (props: WidgetNumberProps) => <span style={props.style}>R$ {numeral(props.valor).format((props.showDecimals ? '0,0.00' : ',0'))}</span>;
export const Litros = (props: WidgetNumberProps) => <span style={props.style}>{numeral(props.valor).format((props.showDecimals ? '0.000' : ',0'))} (L)</span>;
export const Unidades = (props: WidgetNumberProps) => <span style={props.style}>{numeral(props.valor).format('0')} Un</span>;

Reais.defaultProps = {
  showDecimals: true,
};

Litros.defaultProps = {
  showDecimals: true,
};
